import script from "./UnitsView.vue?vue&type=script&setup=true&lang=js"
export * from "./UnitsView.vue?vue&type=script&setup=true&lang=js"

import "./UnitsView.vue?vue&type=style&index=0&id=8b195c9e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b195c9e"]])

export default __exports__